import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {provideBDSTheme} from "@brightside/angular-bds";
import { provideAppAuth, provideOktaAuth } from '@brightside/core/auth';
import { providePluginExecution } from '@brighthub/plugin';
import { BrightnavModule } from '@brighthub/brightnav';
import { BrightnavAdminModule } from '@brighthub/brightnav-admin';
import { AskNaviModule } from '@brighthub/ask-navi';
import { provideHttpClient } from '@angular/common/http';
import { provideCopilot } from '@brighthub/copilot';
import { provideFeatureFlags } from '@brighthub/feature-flags';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { MessageService } from 'primeng/api';
import { MarkdownModule } from 'ngx-markdown';
// APP ENTRY MODULES NEED TO COME FIRST FOR MENU REGISTRATION
import { MARKED_OPTIONS, MarkedOptions } from 'ngx-markdown';
import { SentryService } from '@brighthub/logging';
import { ClientSearchService } from '@brightnav/ui';
import { ClientSessionService } from '@brighthub/uisession';
import { FeedbackService } from '@brighthub/feedback';
import { provideFinancialSnapshot } from '@brightnav/financial-snapshot';

export function markedOptionsFactory(): MarkedOptions {
  return {
    gfm: true,
    breaks: true,
  };
}
export const appConfig: ApplicationConfig = {
  providers: [
    SentryService,
    ...BrightnavModule,
    ...BrightnavAdminModule,
    ...AskNaviModule,
    importProvidersFrom([
      MarkdownModule.forRoot({
        markedOptions: {
          provide: MARKED_OPTIONS,
          useFactory: markedOptionsFactory,
        }
      })
    ]),
    MessageService,
    provideHttpClient(),
    // Global NgRx store; feature state (e.g. Copilot) is registered via provideCopilot() and other providers.
    // Routes and feature providers (e.g. BrightnavModule) register their own routes and providers so the root config stays minimal.
    provideStore(),
    provideEffects(),
    provideFeatureFlags(),
    providePluginExecution(),
    provideAnimationsAsync(),
    provideBDSTheme(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideOktaAuth(),
    provideAppAuth(),
    ClientSearchService,
    ClientSessionService,
    FeedbackService,
    provideCopilot(),
    provideFinancialSnapshot(),
  ],
};
